import SupplierInvoices from '../supplierInvoices/supplierInvoices';
export default function SupplierInvoicesTab(props) {

    const projectId = props.projectId
return (
    <div>
        <SupplierInvoices isInProject = {true} projectId = {projectId}></SupplierInvoices>
    </div>
)};